import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import withStyles from 'isomorphic-style-loader/withStyles'
import classNames from 'classnames';
import AnimateHeight from 'react-animate-height';

import { isZonedSchool, customisedIntlFormatMessage } from '../../utils/helpers';
import messages from '../../locale/messages';

// import Map from '../Map';
import Mapbox from '../Mapbox/Mapbox';
import { Mobile } from '../../utils/mediaQueries';
import { MAPICONS, detectActivationEvent, getMapIconName } from '../../utils/helpers';
import style from './School.scss';
import SchoolHeader from '../SchoolHeader';
import SchoolInfo from '../SchoolInfo';
import SchoolInfoAccordionHs from '../SchoolInfoAccordionHs';
import SchoolInfoAccordionMs from '../SchoolInfoAccordionMs';
import SchoolInfoAccordionK from '../SchoolInfoAccordionK';
import SchoolInfoAccordionD75 from '../SchoolInfoAccordionD75';
import SchoolInfoAccordionSr from '../SchoolInfoAccordionSr';
import SchoolPrograms from '../SchoolPrograms';
import analytics from '../../services/analytics';
import { withRtl } from '../hoc';
import ArrowDownIcon from '../icons/ArrowDown';

class School extends Component {
  static propTypes = {
    applyCard: PropTypes.bool,
    firstName: PropTypes.string,
    headerOpen: PropTypes.bool,
    id: PropTypes.number.isRequired,
    onClick: PropTypes.func.isRequired,
    // info: PropTypes.shape().isRequired,
    loggedIn: PropTypes.bool,
    overview: PropTypes.string.isRequired,
    programOpen: PropTypes.number,
    programClick: PropTypes.func.isRequired,
    showDetails: PropTypes.bool,
    url: PropTypes.string.isRequired,
    latlong: PropTypes.shape({
      lat: PropTypes.number,
      lng: PropTypes.number,
    }).isRequired,
    title: PropTypes.string.isRequired,
    distance: PropTypes.string,
    grades_description: PropTypes.string,
    accessibility: PropTypes.string,
    school: PropTypes.shape({
      dbn: PropTypes.string,
      name: PropTypes.string,
    }).isRequired,
    info: PropTypes.shape({
      address: PropTypes.string,
    }).isRequired,
    getSavedPrograms: PropTypes.func.isRequired,
    getSavedApplications: PropTypes.func.isRequired,
    scheduleProgram: PropTypes.shape(),
    initScheduling: PropTypes.func,
    headerHeadingTagName: PropTypes.string,
    eligibility: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
      }),
    ),
    admissionProcess: PropTypes.string,
    user: PropTypes.shape({}).isRequired,
    admissions_open: PropTypes.bool,
    waitlist_open: PropTypes.bool,
    results_enabled: PropTypes.bool,
  };
  static defaultProps = {
    applyCard: false,
    firstName: null,
    headerOpen: false,
    loggedIn: false,
    programOpen: 0,
    showDetails: false,
    scheduleProgram: null,
    initScheduling: null,
    headerHeadingTagName: 'h1',
    distance: null,
    grades_description: null,
    eligibility: null,
    admissionProcess: null,
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.headerOpen !== prevState.headerOpen) {
      return {
        ...prevState,
        headerOpen: nextProps.headerOpen,
        infoHeight: nextProps.headerOpen ? 'auto' : 0,
      };
    }
    return null;
  }

  constructor(props) {
    super(props);
    this.state = {
      headerOpen: props.headerOpen,
      // details: props.showDetails,
      infoHeight: props.headerOpen ? 'auto' : 0,
      showArrow: true,
    };
  }

  getMarker = () => {
    const { id, latlong, title, info, distance, school, admissionProcess, eligibility, isAffiliatedSRLocation, accessibility } = this.props;
    let headerTitle = title;
    const gradesDescription = this.props.grades_description;
    let icon = 'defaultEligibility';
    let overwriteInnerShapeBy = undefined;
    if (this.props.getSavedPrograms().length) {
      icon = 'savedPrograms';
      overwriteInnerShapeBy = MAPICONS.OverwriteImages.Favorite;
    }
    if (this.props.getSavedApplications().length) {
      icon = 'savedApplications';
      overwriteInnerShapeBy = MAPICONS.OverwriteImages.Applied;
    }
    const isGiftedAndTalented = window.App.state.user.admissionProcess === 'GTAPP' || admissionProcess === 'GTAPP';
    const isMiddleSchool = window.App.state.user.admissionProcess === 'MS' || admissionProcess === 'MS';
    const isSR = window.App.state.user.admissionProcess === 'SR' || admissionProcess === 'SR';
    if (!isGiftedAndTalented && !isMiddleSchool) {
      const isSpecializedHighSchool = school.admission_process === 'SHS'
      const isLaGuardia = school.admission_process === 'LG'
      if (isSpecializedHighSchool || isLaGuardia) {
        icon = MAPICONS.SpecializedSchoolsIcon;
      }
      else if (isSR && isAffiliatedSRLocation)
      {
        icon = MAPICONS.AffiliatedSchoolsIcon;
        headerTitle = 'Affiliated ' + headerTitle;
      }
      else {
        icon = getMapIconName(eligibility, school.other_features);

        if (icon == MAPICONS.MultipleEligibilityMapIcon) {
          if (overwriteInnerShapeBy == MAPICONS.OverwriteImages.Favorite) {
            overwriteInnerShapeBy = icon + "-" + MAPICONS.OverwriteImages.Favorite;
          }
          else if (overwriteInnerShapeBy == MAPICONS.OverwriteImages.Applied) {
            overwriteInnerShapeBy = icon + "-" + MAPICONS.OverwriteImages.Applied;
          }
        }
      }
    }
    // Use global zoned school ids
    if (isZonedSchool(school.dbn, admissionProcess)) {
      icon = MAPICONS.ZonedSchoolIcon;
      const { intl } = this.props;
      headerTitle = customisedIntlFormatMessage(intl, messages.generalStringZoned) + ' ' + headerTitle;
    }
    return [
      {
        id,
        lat: latlong.lat,
        lng: latlong.lng,
        icon,
        label: headerTitle,
        overwriteInnerShapeBy: overwriteInnerShapeBy,
        popup: {
          id,
          distance,
          gradesDescription,
          accessibility,
          name: headerTitle,
          schoolAddress: info.address,
          icon: icon
        },
      },
    ];
  };

  getSchoolAccordionByProcess = () => {
    let admissionProcess = null;
    if (this.props.admissionProcess) {
      admissionProcess = this.props.admissionProcess;}
    else {
      admissionProcess = this.props.admission_process;
    }

    if (
      admissionProcess === 'K' ||
      admissionProcess === 'GT' ||
      admissionProcess === 'PK' ||
      admissionProcess === '2K' ||
      admissionProcess === '3K' ||
      admissionProcess === 'EL'
    ) {
      return (
        <SchoolInfoAccordionK
          {...this.props.info}
          school={this.props.school}
          loggedIn={this.props.loggedIn}
          accordionAnalyticsClick={this.accordionAnalyticsClick}
          overview={this.props.overview}
          admissionProcess={admissionProcess}
          classification={this.props.classification}
          co_located_schools={this.props.co_located_schools}
          class_program_ratio={this.props.class_program_ratio}
          bridge={this.props.bridge}
          assessment_type={this.props.assessment_type}
          accessibility_more_info={this.props.accessibility_more_info}
        />
      );
    } else if (admissionProcess === 'MS') {
      return (
        <SchoolInfoAccordionMs
          {...this.props.info}
          school={this.props.school}
          loggedIn={this.props.loggedIn}
          accordionAnalyticsClick={this.accordionAnalyticsClick}
          classification={this.props.classification}
          co_located_schools={this.props.co_located_schools}
          class_program_ratio={this.props.class_program_ratio}
          bridge={this.props.bridge}
          assessment_type={this.props.assessment_type}
          accessibility_more_info={this.props.accessibility_more_info}
        />
      );
    } else if (admissionProcess === 'HS' || admissionProcess === 'SHS' || admissionProcess === 'LG' || admissionProcess === 'NS') {
      return (
        <SchoolInfoAccordionHs
          {...this.props.info}
          school={this.props.school}
          loggedIn={this.props.loggedIn}
          accordionAnalyticsClick={this.accordionAnalyticsClick}
          classification={this.props.classification}
          co_located_schools={this.props.co_located_schools}
          class_program_ratio={this.props.class_program_ratio}
          bridge={this.props.bridge}
          assessment_type={this.props.assessment_type}
          accessibility_more_info={this.props.accessibility_more_info}
        />
      );
    } else if (admissionProcess === 'D75') {
      return (
        <SchoolInfoAccordionD75
          {...this.props.info}
          school={this.props.school}
          accordionAnalyticsClick={this.accordionAnalyticsClick}
          classification={this.props.classification}
          co_located_schools={this.props.co_located_schools}
          class_program_ratio={this.props.class_program_ratio}
          bridge={this.props.bridge}
          assessment_type={this.props.assessment_type}
          accessibility_more_info={this.props.accessibility_more_info}
        />
      );
    }
    else if(admissionProcess == 'SR'){
      return (
      <SchoolInfoAccordionSr
        {...this.props.info}
        school={this.props.school}
        loggedIn={this.props.loggedIn}
        accordionAnalyticsClick={this.accordionAnalyticsClick}
        classification={this.props.classification}
        co_located_schools={this.props.co_located_schools}
        class_program_ratio={this.props.class_program_ratio}
        bridge={this.props.bridge}
        assessment_type={this.props.assessment_type}
        accessibility_more_info={this.props.accessibility_more_info}
        />
      );
    }

    return null;
  };

  mapPlaceholder = () => {
    this.mapClick();
  };

  handleSchoolClickAnalytics = () => {
    const { school, loggedIn } = this.props;
    let dataDictionary = {
      schoolName: `${school.name}`,
      schoolDbn: `${school.dbn}`,
      loggedIn
    };
    analytics({
      eventLabel: 'schoolClick',
      dataDictionary: dataDictionary,
    });
  };

  toggleHeader = event => {
    const { onClick, id, school } = this.props;
    if (detectActivationEvent(event)) {
      onClick(id, school.dbn);
      if(!this.state.headerOpen){
        this.handleSchoolClickAnalytics();
      }
    }
  };

  accordionAnalyticsClick = accordionLabel => {
    const { school, loggedIn } = this.props;
    analytics({
      eventLabel: 'schoolAccordionOpen',
      dataDictionary: {
        accordionLabel,
        schoolDbn: `${school.dbn}`,
        schoolName: `${school.name}`,
        loggedIn
      },
    });
  };

  scrollPastMap = () => {
    window.scrollBy({ left: 0, top: window.innerHeight, behavior: 'smooth' });
    this.setState({ ...this.state, showArrow: false });
  };

  mapClick = () => { };

  render() {
    const { headerOpen, infoHeight, showArrow } = this.state;
    const {
      id,
      info,
      school,
      applyCard,
      programClick,
      overview,
      scheduleProgram,
      showDetails,
      headerHeadingTagName,
      programOpen,
      admissionProcess,
      loggedIn,
      isAffiliatedSRLocation,
      affiliatedSRLocationText,
    } = this.props;

    if (!school) {
    return null;
    }
    
    const className = classNames(style.root, {
      [style.withButton]: applyCard,
      [style.withShadow]: !applyCard,
      [style.schedule]: scheduleProgram !== null,
      [style.studentAffiliatedSchool]: isAffiliatedSRLocation
    });
    const showShare = headerOpen || (showDetails && scheduleProgram !== null);
    const zonedSchoolDbns = window.App.state.user.get_zoned_school_ids || [];
    const zonedSchool = zonedSchoolDbns.includes(school.dbn);
    const zonedSchoolIdText = zonedSchool ? (window.App.state.user.get_zoned_school_card_text || '') : '';
    return (
      <div className={className} data-coachmark="saved-step-2">
        <SchoolHeader
          {...this.props}
          headerId={id}
          programOpen={programOpen}
          opened={headerOpen}
          isAffiliatedSRLocation={isAffiliatedSRLocation}
          affiliatedSRLocationText={affiliatedSRLocationText}
          onClick={this.toggleHeader}
          showShare={showShare}
          headingTagName={headerHeadingTagName}
          admissionProcess={admissionProcess}
          dbn={school.dbn}
          zonedSchool={zonedSchool}
          zonedSchoolIdText={zonedSchoolIdText}
        />
        {headerOpen && (
          <div>
            <Mobile>
              <div className={style.cardMapWrapperInline}>
                <Mapbox
                  //
                  {...this.props}
                  markers={this.getMarker()}
                  mobile
                  isSchoolDetail
                />
                {showArrow && (
                  <div className={style.buttonContainer}>
                    <button
                      onClick={this.scrollPastMap}
                      className={classNames(style.scrollDownButton, {
                        [style.loggedIn]: loggedIn,
                      })}
                    >
                      <ArrowDownIcon size={19} fill="#fff" />
                    </button>
                  </div>
                )}
                {/* <Map
                  {...this.props}
                  markers={this.getMarker()}
                  onMapMove={this.mapPlaceholder}
                  onMarkerClick={this.mapClick}
                  // googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyABxs6eZrUnaBPvqkm6OoclJmeSnc7SUkg&v=3.exp"
                  loadingElement={<div style={{ height: '100%' }} />}
                  containerElement={<div style={{ height: '100%' }} />}
                  mapElement={<div style={{ height: '100%' }} />}
                  mobile
                  isSchoolDetail
                  admissionProcess={admissionProcess}
                /> */}
              </div>
            </Mobile>
          </div>
        )}
        <AnimateHeight duration={300} height={infoHeight}>
          <SchoolInfo
            {...info}
            school={school}
            overview={overview}
            showDetails={showDetails}
            admissionProcess={admissionProcess}
          />
          {this.getSchoolAccordionByProcess()}
        </AnimateHeight>
        <SchoolPrograms
          {...this.props}
          schoolUrl={this.props.url}
          showDetails={showDetails}
          applyCard={applyCard}
          programClick={programClick}
          admissionProcess={admissionProcess}
          is_last_school={this.props.is_last_school || showDetails}
        />
      </div>
    );
  }
}

const mapStateToProps = ({ user }) => ({
  user,
});

export { School };
export default compose(
  injectIntl,
  withRtl(style),
  withStyles(style),
  connect(mapStateToProps),
)(School);
